import { MemberStatus, PLCustomerData } from 'types';
import { postToApigee } from 'utils/fetchFromApigee';

export const checkMembershipStatus = async (
	customerData: PLCustomerData
): Promise<MemberStatus> => {
	const {
		birthdate,
		city,
		email,
		gender,
		houseNumber,
		houseNumberSuffix,
		initials,
		isMember,
		lastName,
		lastNamePrefix,
		phoneNumber,
		postalCode,
		street,
	} = customerData;

	const membershipResponse = postToApigee('v1/membership-check/status', {
		city,
		dateOfBirth: birthdate,
		email,
		familyName: lastName,
		houseNumber,
		houseNumberAddition: houseNumberSuffix,
		initials: initials.replaceAll(/\s/g, ''),
		postalCode,
		street,
		surnamePrefix: lastNamePrefix,
		prefix: lastNamePrefix,
		telephone: phoneNumber,
		gender,
		membership: isMember,
	})
		.then((res) => res.json())
		.then((response: MemberStatus) => response);

	return membershipResponse;
};
